const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3001"; // fallback for local dev

export default API_BASE_URL;
